import React from 'react';

import classes from './CustomersTabs.module.scss';
import { LbTabs, LbToggleTabsList, TabOption } from '../../../../shared/components/tabs';
import {
  SETUP_STATUS,
  SetupStatusTab,
} from '../../../interfaces/ScanIqCustomerSetupInfo';

type CustomersTabsProps = {
  value: SetupStatusTab;
  onValueChange: (value: SetupStatusTab) => void;
};

const customersTabsConfig: TabOption<SetupStatusTab>[] = [
  { label: 'All Customers', value: SETUP_STATUS.COMPLETED },
  { label: 'Incomplete Customers', value: SETUP_STATUS.NEED_SETUP },
];

const CustomersTabs = ({ value, onValueChange }: CustomersTabsProps) => {
  return (
    <LbTabs
      value={value}
      onValueChange={onValueChange}
      data-test-id="customers-setup-status-tabs"
    >
      <LbToggleTabsList
        tabsConfig={customersTabsConfig}
        size="small"
        fullWidth
        className={classes.tabs}
      />
    </LbTabs>
  );
};

export { CustomersTabs };
